export const Icons = {
  Plus0: 'uil uil-0-plus',
  Plus10: 'uil uil-10-plus',
  Plus12: 'uil uil-12-plus',
  Plus13: 'uil uil-13-plus',
  Plus16: 'uil uil-16-plus',
  Plus17: 'uil uil-17-plus',
  Plus18: 'uil uil-18-plus',
  Plus21: 'uil uil-21-plus',
  Plus3: 'uil uil-3-plus',
  px500: 'uil uil-500px',
  Plus6: 'uil uil-6-plus',
  abacus: 'uil uil-abacus',
  accessibleIconAlt: 'uil uil-accessible-icon-alt',
  adjust: 'uil uil-adjust',
  adjustAlt: 'uil uil-adjust-alt',
  adjustCircle: 'uil uil-adjust-circle',
  adjustHalf: 'uil uil-adjust-half',
  adobe: 'uil uil-adobe',
  adobeAlt: 'uil uil-adobe-alt',
  airplay: 'uil uil-airplay',
  align: 'uil uil-align',
  alignAlt: 'uil uil-align-alt',
  alignCenter: 'uil uil-align-center',
  alignCenterAlt: 'uil uil-align-center-alt',
  alignCenterH: 'uil uil-align-center-h',
  alignCenterJustify: 'uil uil-align-center-justify',
  alignCenterV: 'uil uil-align-center-v',
  alignJustify: 'uil uil-align-justify',
  alignLeft: 'uil uil-align-left',
  alignLeftJustify: 'uil uil-align-left-justify',
  alignLetterRight: 'uil uil-align-letter-right',
  alignRight: 'uil uil-align-right',
  alignRightJustify: 'uil uil-align-right-justify',
  amazon: 'uil uil-amazon',
  ambulance: 'uil uil-ambulance',
  analysis: 'uil uil-analysis',
  analytics: 'uil uil-analytics',
  anchor: 'uil uil-anchor',
  android: 'uil uil-android',
  androidAlt: 'uil uil-android-alt',
  androidPhoneSlash: 'uil uil-android-phone-slash',
  angleDoubleDown: 'uil uil-angle-double-down',
  angleDoubleLeft: 'uil uil-angle-double-left',
  angleDoubleRight: 'uil uil-angle-double-right',
  angleDoubleUp: 'uil uil-angle-double-up',
  angleDown: 'uil uil-angle-down',
  angleLeft: 'uil uil-angle-left',
  angleLeftB: 'uil uil-angle-left-b',
  angleRight: 'uil uil-angle-right',
  angleRightB: 'uil uil-angle-right-b',
  angleUp: 'uil uil-angle-up',
  angry: 'uil uil-angry',
  ankh: 'uil uil-ankh',
  annoyed: 'uil uil-annoyed',
  annoyedAlt: 'uil uil-annoyed-alt',
  apple: 'uil uil-apple',
  appleAlt: 'uil uil-apple-alt',
  apps: 'uil uil-apps',
  archive: 'uil uil-archive',
  archiveAlt: 'uil uil-archive-alt',
  archway: 'uil uil-archway',
  arrow: 'uil uil-arrow',
  arrowBreak: 'uil uil-arrow-break',
  arrowCircleDown: 'uil uil-arrow-circle-down',
  arrowCircleLeft: 'uil uil-arrow-circle-left',
  arrowCircleRight: 'uil uil-arrow-circle-right',
  arrowCircleUp: 'uil uil-arrow-circle-up',
  arrowCompressH: 'uil uil-arrow-compress-h',
  arrowDown: 'uil uil-arrow-down',
  arrowDownLeft: 'uil uil-arrow-down-left',
  arrowDownRight: 'uil uil-arrow-down-right',
  arrowFromRight: 'uil uil-arrow-from-right',
  arrowFromTop: 'uil uil-arrow-from-top',
  arrowGrowth: 'uil uil-arrow-growth',
  arrowLeft: 'uil uil-arrow-left',
  arrowRandom: 'uil uil-arrow-random',
  arrowResizeDiagonal: 'uil uil-arrow-resize-diagonal',
  arrowRight: 'uil uil-arrow-right',
  arrowToBottom: 'uil uil-arrow-to-bottom',
  arrowToRight: 'uil uil-arrow-to-right',
  arrowUp: 'uil uil-arrow-up',
  arrowUpLeft: 'uil uil-arrow-up-left',
  arrowUpRight: 'uil uil-arrow-up-right',
  arrowsH: 'uil uil-arrows-h',
  arrowsHAlt: 'uil uil-arrows-h-alt',
  arrowsLeftDown: 'uil uil-arrows-left-down',
  arrowsMaximize: 'uil uil-arrows-maximize',
  arrowsMerge: 'uil uil-arrows-merge',
  arrowsResize: 'uil uil-arrows-resize',
  arrowsResizeH: 'uil uil-arrows-resize-h',
  arrowsResizeV: 'uil uil-arrows-resize-v',
  arrowsRightDown: 'uil uil-arrows-right-down',
  arrowsShrinkH: 'uil uil-arrows-shrink-h',
  arrowsShrinkV: 'uil uil-arrows-shrink-v',
  arrowsUpRight: 'uil uil-arrows-up-right',
  arrowsV: 'uil uil-arrows-v',
  arrowsVAlt: 'uil uil-arrows-v-alt',
  assistiveListeningSystems: 'uil uil-assistive-listening-systems',
  asterisk: 'uil uil-asterisk',
  at: 'uil uil-at',
  atom: 'uil uil-atom',
  autoFlash: 'uil uil-auto-flash',
  award: 'uil uil-award',
  awardAlt: 'uil uil-award-alt',
  babyCarriage: 'uil uil-baby-carriage',
  backpack: 'uil uil-backpack',
  backspace: 'uil uil-backspace',
  backward: 'uil uil-backward',
  bag: 'uil uil-bag',
  bagAlt: 'uil uil-bag-alt',
  bagSlash: 'uil uil-bag-slash',
  balanceScale: 'uil uil-balance-scale',
  ban: 'uil uil-ban',
  bandAid: 'uil uil-band-aid',
  bars: 'uil uil-bars',
  baseballBall: 'uil uil-baseball-ball',
  basketball: 'uil uil-basketball',
  basketballHoop: 'uil uil-basketball-hoop',
  bath: 'uil uil-bath',
  batteryBolt: 'uil uil-battery-bolt',
  batteryEmpty: 'uil uil-battery-empty',
  bed: 'uil uil-bed',
  bedDouble: 'uil uil-bed-double',
  behance: 'uil uil-behance',
  behanceAlt: 'uil uil-behance-alt',
  bell: 'uil uil-bell',
  bellSchool: 'uil uil-bell-school',
  bellSlash: 'uil uil-bell-slash',
  bill: 'uil uil-bill',
  bing: 'uil uil-bing',
  bitcoin: 'uil uil-bitcoin',
  bitcoinAlt: 'uil uil-bitcoin-alt',
  bitcoinCircle: 'uil uil-bitcoin-circle',
  bitcoinSign: 'uil uil-bitcoin-sign',
  blackBerry: 'uil uil-black-berry',
  blogger: 'uil uil-blogger',
  bloggerAlt: 'uil uil-blogger-alt',
  bluetoothB: 'uil uil-bluetooth-b',
  bold: 'uil uil-bold',
  bolt: 'uil uil-bolt',
  boltAlt: 'uil uil-bolt-alt',
  boltSlash: 'uil uil-bolt-slash',
  book: 'uil uil-book',
  bookAlt: 'uil uil-book-alt',
  bookMedical: 'uil uil-book-medical',
  bookOpen: 'uil uil-book-open',
  bookReader: 'uil uil-book-reader',
  bookmark: 'uil uil-bookmark',
  bookmarkFull: 'uil uil-bookmark-full',
  books: 'uil uil-books',
  boombox: 'uil uil-boombox',
  borderAlt: 'uil uil-border-alt',
  borderBottom: 'uil uil-border-bottom',
  borderClear: 'uil uil-border-clear',
  borderHorizontal: 'uil uil-border-horizontal',
  borderInner: 'uil uil-border-inner',
  borderLeft: 'uil uil-border-left',
  borderOut: 'uil uil-border-out',
  borderRight: 'uil uil-border-right',
  borderTop: 'uil uil-border-top',
  borderVertical: 'uil uil-border-vertical',
  bowlingBall: 'uil uil-bowling-ball',
  box: 'uil uil-box',
  bracketsCurly: 'uil uil-brackets-curly',
  brain: 'uil uil-brain',
  briefcase: 'uil uil-briefcase',
  briefcaseAlt: 'uil uil-briefcase-alt',
  bright: 'uil uil-bright',
  brightness: 'uil uil-brightness',
  brightnessEmpty: 'uil uil-brightness-empty',
  brightnessHalf: 'uil uil-brightness-half',
  brightnessLow: 'uil uil-brightness-low',
  brightnessMinus: 'uil uil-brightness-minus',
  brightnessPlus: 'uil uil-brightness-plus',
  bringBottom: 'uil uil-bring-bottom',
  bringFront: 'uil uil-bring-front',
  browser: 'uil uil-browser',
  brushAlt: 'uil uil-brush-alt',
  bug: 'uil uil-bug',
  building: 'uil uil-building',
  bullseye: 'uil uil-bullseye',
  bus: 'uil uil-bus',
  busAlt: 'uil uil-bus-alt',
  busSchool: 'uil uil-bus-school',
  calculator: 'uil uil-calculator',
  calculatorAlt: 'uil uil-calculator-alt',
  calendarAlt: 'uil uil-calendar-alt',
  calendarSlash: 'uil uil-calendar-slash',
  calender: 'uil uil-calender',
  calling: 'uil uil-calling',
  camera: 'uil uil-camera',
  cameraChange: 'uil uil-camera-change',
  cameraPlus: 'uil uil-camera-plus',
  cameraSlash: 'uil uil-camera-slash',
  cancel: 'uil uil-cancel',
  capsule: 'uil uil-capsule',
  capture: 'uil uil-capture',
  car: 'uil uil-car',
  carSideview: 'uil uil-car-sideview',
  carSlash: 'uil uil-car-slash',
  carWash: 'uil uil-car-wash',
  cardAtm: 'uil uil-card-atm',
  caretRight: 'uil uil-caret-right',
  cell: 'uil uil-cell',
  celsius: 'uil uil-celsius',
  channel: 'uil uil-channel',
  channelAdd: 'uil uil-channel-add',
  chart: 'uil uil-chart',
  chartBar: 'uil uil-chart-bar',
  chartBarAlt: 'uil uil-chart-bar-alt',
  chartDown: 'uil uil-chart-down',
  chartGrowth: 'uil uil-chart-growth',
  chartGrowthAlt: 'uil uil-chart-growth-alt',
  chartLine: 'uil uil-chart-line',
  chartPie: 'uil uil-chart-pie',
  chartPieAlt: 'uil uil-chart-pie-alt',
  chat: 'uil uil-chat',
  chatBubbleUser: 'uil uil-chat-bubble-user',
  chatInfo: 'uil uil-chat-info',
  check: 'uil uil-check',
  checkCircle: 'uil uil-check-circle',
  checkSquare: 'uil uil-check-square',
  circle: 'uil uil-circle',
  circleLayer: 'uil uil-circle-layer',
  circuit: 'uil uil-circuit',
  clapperBoard: 'uil uil-clapper-board',
  clinicMedical: 'uil uil-clinic-medical',
  clipboard: 'uil uil-clipboard',
  clipboardAlt: 'uil uil-clipboard-alt',
  clipboardBlank: 'uil uil-clipboard-blank',
  clipboardNotes: 'uil uil-clipboard-notes',
  clock: 'uil uil-clock',
  clockEight: 'uil uil-clock-eight',
  clockFive: 'uil uil-clock-five',
  clockNine: 'uil uil-clock-nine',
  clockSeven: 'uil uil-clock-seven',
  clockTen: 'uil uil-clock-ten',
  clockThree: 'uil uil-clock-three',
  clockTwo: 'uil uil-clock-two',
  closedCaptioning: 'uil uil-closed-captioning',
  closedCaptioningSlash: 'uil uil-closed-captioning-slash',
  cloud: 'uil uil-cloud',
  cloudBlock: 'uil uil-cloud-block',
  cloudBookmark: 'uil uil-cloud-bookmark',
  cloudCheck: 'uil uil-cloud-check',
  cloudComputing: 'uil uil-cloud-computing',
  cloudDataConnection: 'uil uil-cloud-data-connection',
  cloudDatabaseTree: 'uil uil-cloud-database-tree',
  cloudDownload: 'uil uil-cloud-download',
  cloudDrizzle: 'uil uil-cloud-drizzle',
  cloudExclamation: 'uil uil-cloud-exclamation',
  cloudHail: 'uil uil-cloud-hail',
  cloudHeart: 'uil uil-cloud-heart',
  cloudInfo: 'uil uil-cloud-info',
  cloudLock: 'uil uil-cloud-lock',
  cloudMeatball: 'uil uil-cloud-meatball',
  cloudMoon: 'uil uil-cloud-moon',
  cloudMoonHail: 'uil uil-cloud-moon-hail',
  cloudMoonMeatball: 'uil uil-cloud-moon-meatball',
  cloudMoonRain: 'uil uil-cloud-moon-rain',
  cloudMoonShowers: 'uil uil-cloud-moon-showers',
  cloudQuestion: 'uil uil-cloud-question',
  cloudRain: 'uil uil-cloud-rain',
  cloudRainSun: 'uil uil-cloud-rain-sun',
  cloudRedo: 'uil uil-cloud-redo',
  cloudShare: 'uil uil-cloud-share',
  cloudShield: 'uil uil-cloud-shield',
  cloudShowers: 'uil uil-cloud-showers',
  cloudShowersAlt: 'uil uil-cloud-showers-alt',
  cloudShowersHeavy: 'uil uil-cloud-showers-heavy',
  cloudSlash: 'uil uil-cloud-slash',
  cloudSun: 'uil uil-cloud-sun',
  cloudSunHail: 'uil uil-cloud-sun-hail',
  cloudSunMeatball: 'uil uil-cloud-sun-meatball',
  cloudSunRain: 'uil uil-cloud-sun-rain',
  cloudSunRainAlt: 'uil uil-cloud-sun-rain-alt',
  cloudSunTear: 'uil uil-cloud-sun-tear',
  cloudTimes: 'uil uil-cloud-times',
  cloudUnlock: 'uil uil-cloud-unlock',
  cloudUpload: 'uil uil-cloud-upload',
  cloudWifi: 'uil uil-cloud-wifi',
  cloudWind: 'uil uil-cloud-wind',
  clouds: 'uil uil-clouds',
  club: 'uil uil-club',
  codeBranch: 'uil uil-code-branch',
  coffee: 'uil uil-coffee',
  cog: 'uil uil-cog',
  coins: 'uil uil-coins',
  columns: 'uil uil-columns',
  comment: 'uil uil-comment',
  commentAdd: 'uil uil-comment-add',
  commentAlt: 'uil uil-comment-alt',
  commentAltBlock: 'uil uil-comment-alt-block',
  commentAltChartLines: 'uil uil-comment-alt-chart-lines',
  commentAltCheck: 'uil uil-comment-alt-check',
  commentAltDots: 'uil uil-comment-alt-dots',
  commentAltDownload: 'uil uil-comment-alt-download',
  commentAltEdit: 'uil uil-comment-alt-edit',
  commentAltExclamation: 'uil uil-comment-alt-exclamation',
  commentAltHeart: 'uil uil-comment-alt-heart',
  commentAltImage: 'uil uil-comment-alt-image',
  commentAltInfo: 'uil uil-comment-alt-info',
  commentAltLines: 'uil uil-comment-alt-lines',
  commentAltLock: 'uil uil-comment-alt-lock',
  commentAltMedical: 'uil uil-comment-alt-medical',
  commentAltMessage: 'uil uil-comment-alt-message',
  commentAltNotes: 'uil uil-comment-alt-notes',
  commentAltPlus: 'uil uil-comment-alt-plus',
  commentAltQuestion: 'uil uil-comment-alt-question',
  commentAltRedo: 'uil uil-comment-alt-redo',
  commentAltSearch: 'uil uil-comment-alt-search',
  commentAltShare: 'uil uil-comment-alt-share',
  commentAltShield: 'uil uil-comment-alt-shield',
  commentAltSlash: 'uil uil-comment-alt-slash',
  commentAltUpload: 'uil uil-comment-alt-upload',
  commentAltVerify: 'uil uil-comment-alt-verify',
  commentBlock: 'uil uil-comment-block',
  commentChartLine: 'uil uil-comment-chart-line',
  commentCheck: 'uil uil-comment-check',
  commentDots: 'uil uil-comment-dots',
  commentDownload: 'uil uil-comment-download',
  commentEdit: 'uil uil-comment-edit',
  commentExclamation: 'uil uil-comment-exclamation',
  commentHeart: 'uil uil-comment-heart',
  commentImage: 'uil uil-comment-image',
  commentInfo: 'uil uil-comment-info',
  commentInfoAlt: 'uil uil-comment-info-alt',
  commentLines: 'uil uil-comment-lines',
  commentLock: 'uil uil-comment-lock',
  commentMedical: 'uil uil-comment-medical',
  commentMessage: 'uil uil-comment-message',
  commentNotes: 'uil uil-comment-notes',
  commentPlus: 'uil uil-comment-plus',
  commentQuestion: 'uil uil-comment-question',
  commentRedo: 'uil uil-comment-redo',
  commentSearch: 'uil uil-comment-search',
  commentShare: 'uil uil-comment-share',
  commentShield: 'uil uil-comment-shield',
  commentSlash: 'uil uil-comment-slash',
  commentUpload: 'uil uil-comment-upload',
  commentVerify: 'uil uil-comment-verify',
  comments: 'uil uil-comments',
  commentsAlt: 'uil uil-comments-alt',
  compactDisc: 'uil uil-compact-disc',
  comparison: 'uil uil-comparison',
  compass: 'uil uil-compass',
  compress: 'uil uil-compress',
  compressAlt: 'uil uil-compress-alt',
  compressAltLeft: 'uil uil-compress-alt-left',
  compressArrows: 'uil uil-compress-arrows',
  compressLines: 'uil uil-compress-lines',
  compressPoint: 'uil uil-compress-point',
  compressV: 'uil uil-compress-v',
  confused: 'uil uil-confused',
  constructor: 'uil uil-constructor',
  copy: 'uil uil-copy',
  copyAlt: 'uil uil-copy-alt',
  copyLandscape: 'uil uil-copy-landscape',
  copyright: 'uil uil-copyright',
  cornerDownLeft: 'uil uil-corner-down-left',
  cornerDownRight: 'uil uil-corner-down-right',
  cornerDownRightAlt: 'uil uil-corner-down-right-alt',
  cornerLeftDown: 'uil uil-corner-left-down',
  cornerRightDown: 'uil uil-corner-right-down',
  cornerUpLeft: 'uil uil-corner-up-left',
  cornerUpLeftAlt: 'uil uil-corner-up-left-alt',
  cornerUpRight: 'uil uil-corner-up-right',
  cornerUpRightAlt: 'uil uil-corner-up-right-alt',
  coronavirus: 'uil uil-coronavirus',
  createDashboard: 'uil uil-create-dashboard',
  creativeCommonsPd: 'uil uil-creative-commons-pd',
  creditCard: 'uil uil-credit-card',
  creditCardSearch: 'uil uil-credit-card-search',
  crockery: 'uil uil-crockery',
  cropAlt: 'uil uil-crop-alt',
  cropAltRotateLeft: 'uil uil-crop-alt-rotate-left',
  cropAltRotateRight: 'uil uil-crop-alt-rotate-right',
  crosshair: 'uil uil-crosshair',
  crosshairAlt: 'uil uil-crosshair-alt',
  crosshairs: 'uil uil-crosshairs',
  css3Simple: 'uil uil-css3-simple',
  cube: 'uil uil-cube',
  dashboard: 'uil uil-dashboard',
  dataSharing: 'uil uil-data-sharing',
  database: 'uil uil-database',
  databaseAlt: 'uil uil-database-alt',
  desert: 'uil uil-desert',
  desktop: 'uil uil-desktop',
  desktopAlt: 'uil uil-desktop-alt',
  desktopAltSlash: 'uil uil-desktop-alt-slash',
  desktopCloudAlt: 'uil uil-desktop-cloud-alt',
  desktopSlash: 'uil uil-desktop-slash',
  dialpad: 'uil uil-dialpad',
  dialpadAlt: 'uil uil-dialpad-alt',
  diamond: 'uil uil-diamond',
  diary: 'uil uil-diary',
  diaryAlt: 'uil uil-diary-alt',
  diceFive: 'uil uil-dice-five',
  diceFour: 'uil uil-dice-four',
  diceOne: 'uil uil-dice-one',
  diceSix: 'uil uil-dice-six',
  diceThree: 'uil uil-dice-three',
  diceTwo: 'uil uil-dice-two',
  direction: 'uil uil-direction',
  directions: 'uil uil-directions',
  discord: 'uil uil-discord',
  dizzyMeh: 'uil uil-dizzy-meh',
  dna: 'uil uil-dna',
  docker: 'uil uil-docker',
  documentInfo: 'uil uil-document-info',
  documentLayoutCenter: 'uil uil-document-layout-center',
  documentLayoutLeft: 'uil uil-document-layout-left',
  documentLayoutRight: 'uil uil-document-layout-right',
  dollarAlt: 'uil uil-dollar-alt',
  dollarSign: 'uil uil-dollar-sign',
  dollarSignAlt: 'uil uil-dollar-sign-alt',
  downloadAlt: 'uil uil-download-alt',
  draggabledots: 'uil uil-draggabledots',
  dribbble: 'uil uil-dribbble',
  drill: 'uil uil-drill',
  dropbox: 'uil uil-dropbox',
  dumbbell: 'uil uil-dumbbell',
  ear: 'uil uil-ear',
  edit: 'uil uil-edit',
  editAlt: 'uil uil-edit-alt',
  elipsisDoubleVAlt: 'uil uil-elipsis-double-v-alt',
  ellipsisH: 'uil uil-ellipsis-h',
  ellipsisV: 'uil uil-ellipsis-v',
  emoji: 'uil uil-emoji',
  englishToChinese: 'uil uil-english-to-chinese',
  enter: 'uil uil-enter',
  envelope: 'uil uil-envelope',
  envelopeAdd: 'uil uil-envelope-add',
  envelopeAlt: 'uil uil-envelope-alt',
  envelopeBlock: 'uil uil-envelope-block',
  envelopeBookmark: 'uil uil-envelope-bookmark',
  envelopeCheck: 'uil uil-envelope-check',
  envelopeDownload: 'uil uil-envelope-download',
  envelopeDownloadAlt: 'uil uil-envelope-download-alt',
  envelopeEdit: 'uil uil-envelope-edit',
  envelopeExclamation: 'uil uil-envelope-exclamation',
  envelopeHeart: 'uil uil-envelope-heart',
  envelopeInfo: 'uil uil-envelope-info',
  envelopeLock: 'uil uil-envelope-lock',
  envelopeMinus: 'uil uil-envelope-minus',
  envelopeOpen: 'uil uil-envelope-open',
  envelopeQuestion: 'uil uil-envelope-question',
  envelopeReceive: 'uil uil-envelope-receive',
  envelopeRedo: 'uil uil-envelope-redo',
  envelopeSearch: 'uil uil-envelope-search',
  envelopeSend: 'uil uil-envelope-send',
  envelopeShare: 'uil uil-envelope-share',
  envelopeShield: 'uil uil-envelope-shield',
  envelopeStar: 'uil uil-envelope-star',
  envelopeTimes: 'uil uil-envelope-times',
  envelopeUpload: 'uil uil-envelope-upload',
  envelopeUploadAlt: 'uil uil-envelope-upload-alt',
  envelopes: 'uil uil-envelopes',
  equalCircle: 'uil uil-equal-circle',
  estate: 'uil uil-estate',
  euro: 'uil uil-euro',
  euroCircle: 'uil uil-euro-circle',
  exchange: 'uil uil-exchange',
  exchangeAlt: 'uil uil-exchange-alt',
  exclamation: 'uil uil-exclamation',
  exclamationCircle: 'uil uil-exclamation-circle',
  exclamationOctagon: 'uil uil-exclamation-octagon',
  exclamationTriangle: 'uil uil-exclamation-triangle',
  exclude: 'uil uil-exclude',
  expandAlt: 'uil uil-expand-alt',
  expandArrows: 'uil uil-expand-arrows',
  expandArrowsAlt: 'uil uil-expand-arrows-alt',
  expandFromCorner: 'uil uil-expand-from-corner',
  expandLeft: 'uil uil-expand-left',
  expandRight: 'uil uil-expand-right',
  export: 'uil uil-export',
  exposureAlt: 'uil uil-exposure-alt',
  exposureIncrease: 'uil uil-exposure-increase',
  externalLinkAlt: 'uil uil-external-link-alt',
  eye: 'uil uil-eye',
  eyeSlash: 'uil uil-eye-slash',
  facebook: 'uil uil-facebook',
  facebookF: 'uil uil-facebook-f',
  facebookMessenger: 'uil uil-facebook-messenger',
  facebookMessengerAlt: 'uil uil-facebook-messenger-alt',
  fahrenheit: 'uil uil-fahrenheit',
  fastMail: 'uil uil-fast-mail',
  fastMailAlt: 'uil uil-fast-mail-alt',
  favorite: 'uil uil-favorite',
  feedback: 'uil uil-feedback',
  fidgetSpinner: 'uil uil-fidget-spinner',
  file: 'uil uil-file',
  fileAlt: 'uil uil-file-alt',
  fileBlank: 'uil uil-file-blank',
  fileBlockAlt: 'uil uil-file-block-alt',
  fileBookmarkAlt: 'uil uil-file-bookmark-alt',
  fileCheck: 'uil uil-file-check',
  fileCheckAlt: 'uil uil-file-check-alt',
  fileContract: 'uil uil-file-contract',
  fileContractDollar: 'uil uil-file-contract-dollar',
  fileCopyAlt: 'uil uil-file-copy-alt',
  fileDownload: 'uil uil-file-download',
  fileDownloadAlt: 'uil uil-file-download-alt',
  fileEditAlt: 'uil uil-file-edit-alt',
  fileExclamation: 'uil uil-file-exclamation',
  fileExclamationAlt: 'uil uil-file-exclamation-alt',
  fileExport: 'uil uil-file-export',
  fileGraph: 'uil uil-file-graph',
  fileHeart: 'uil uil-file-heart',
  fileImport: 'uil uil-file-import',
  fileInfoAlt: 'uil uil-file-info-alt',
  fileLandscape: 'uil uil-file-landscape',
  fileLandscapeAlt: 'uil uil-file-landscape-alt',
  fileLanscapeSlash: 'uil uil-file-lanscape-slash',
  fileLockAlt: 'uil uil-file-lock-alt',
  fileMedical: 'uil uil-file-medical',
  fileMedicalAlt: 'uil uil-file-medical-alt',
  fileMinus: 'uil uil-file-minus',
  fileMinusAlt: 'uil uil-file-minus-alt',
  fileNetwork: 'uil uil-file-network',
  filePlus: 'uil uil-file-plus',
  filePlusAlt: 'uil uil-file-plus-alt',
  fileQuestion: 'uil uil-file-question',
  fileQuestionAlt: 'uil uil-file-question-alt',
  fileRedoAlt: 'uil uil-file-redo-alt',
  fileSearchAlt: 'uil uil-file-search-alt',
  fileShareAlt: 'uil uil-file-share-alt',
  fileShieldAlt: 'uil uil-file-shield-alt',
  fileSlash: 'uil uil-file-slash',
  fileTimes: 'uil uil-file-times',
  fileTimesAlt: 'uil uil-file-times-alt',
  fileUpload: 'uil uil-file-upload',
  fileUploadAlt: 'uil uil-file-upload-alt',
  filesLandscapes: 'uil uil-files-landscapes',
  filesLandscapesAlt: 'uil uil-files-landscapes-alt',
  film: 'uil uil-film',
  filter: 'uil uil-filter',
  filterSlash: 'uil uil-filter-slash',
  fire: 'uil uil-fire',
  flask: 'uil uil-flask',
  flaskPotion: 'uil uil-flask-potion',
  flipH: 'uil uil-flip-h',
  flipHAlt: 'uil uil-flip-h-alt',
  flipV: 'uil uil-flip-v',
  flipVAlt: 'uil uil-flip-v-alt',
  flower: 'uil uil-flower',
  focus: 'uil uil-focus',
  focusAdd: 'uil uil-focus-add',
  focusTarget: 'uil uil-focus-target',
  folder: 'uil uil-folder',
  folderCheck: 'uil uil-folder-check',
  folderDownload: 'uil uil-folder-download',
  folderExclamation: 'uil uil-folder-exclamation',
  folderHeart: 'uil uil-folder-heart',
  folderInfo: 'uil uil-folder-info',
  folderLock: 'uil uil-folder-lock',
  folderMedical: 'uil uil-folder-medical',
  folderMinus: 'uil uil-folder-minus',
  folderNetwork: 'uil uil-folder-network',
  folderOpen: 'uil uil-folder-open',
  folderPlus: 'uil uil-folder-plus',
  folderQuestion: 'uil uil-folder-question',
  folderSlash: 'uil uil-folder-slash',
  folderTimes: 'uil uil-folder-times',
  folderUpload: 'uil uil-folder-upload',
  font: 'uil uil-font',
  football: 'uil uil-football',
  footballAmerican: 'uil uil-football-american',
  footballBall: 'uil uil-football-ball',
  forecastcloudMoonTear: 'uil uil-forecastcloud-moon-tear',
  forwadedCall: 'uil uil-forwaded-call',
  forward: 'uil uil-forward',
  frown: 'uil uil-frown',
  gameStructure: 'uil uil-game-structure',
  gift: 'uil uil-gift',
  github: 'uil uil-github',
  githubAlt: 'uil uil-github-alt',
  gitlab: 'uil uil-gitlab',
  glass: 'uil uil-glass',
  glassMartini: 'uil uil-glass-martini',
  glassMartiniAlt: 'uil uil-glass-martini-alt',
  glassMartiniAltSlash: 'uil uil-glass-martini-alt-slash',
  glassTea: 'uil uil-glass-tea',
  globe: 'uil uil-globe',
  gold: 'uil uil-gold',
  golfBall: 'uil uil-golf-ball',
  google: 'uil uil-google',
  googleDrive: 'uil uil-google-drive',
  googleDriveAlt: 'uil uil-google-drive-alt',
  googleHangouts: 'uil uil-google-hangouts',
  googleHangoutsAlt: 'uil uil-google-hangouts-alt',
  googlePlay: 'uil uil-google-play',
  graduationCap: 'uil uil-graduation-cap',
  graphBar: 'uil uil-graph-bar',
  grid: 'uil uil-grid',
  grids: 'uil uil-grids',
  grin: 'uil uil-grin',
  grinTongueWink: 'uil uil-grin-tongue-wink',
  grinTongueWinkAlt: 'uil uil-grin-tongue-wink-alt',
  gripHorizontalLine: 'uil uil-grip-horizontal-line',
  hardHat: 'uil uil-hard-hat',
  hdd: 'uil uil-hdd',
  headSide: 'uil uil-head-side',
  headSideCough: 'uil uil-head-side-cough',
  headSideMask: 'uil uil-head-side-mask',
  headphoneSlash: 'uil uil-headphone-slash',
  headphones: 'uil uil-headphones',
  headphonesAlt: 'uil uil-headphones-alt',
  heart: 'uil uil-heart',
  heartAlt: 'uil uil-heart-alt',
  heartBreak: 'uil uil-heart-break',
  heartMedical: 'uil uil-heart-medical',
  heartRate: 'uil uil-heart-rate',
  heartSign: 'uil uil-heart-sign',
  heartbeat: 'uil uil-heartbeat',
  hindiToChinese: 'uil uil-hindi-to-chinese',
  hipchat: 'uil uil-hipchat',
  history: 'uil uil-history',
  historyAlt: 'uil uil-history-alt',
  home: 'uil uil-home',
  horizontalAlignCenter: 'uil uil-horizontal-align-center',
  horizontalAlignLeft: 'uil uil-horizontal-align-left',
  horizontalAlignRight: 'uil uil-horizontal-align-right',
  horizontalDistributionCenter: 'uil uil-horizontal-distribution-center',
  horizontalDistributionLeft: 'uil uil-horizontal-distribution-left',
  horizontalDistributionRight: 'uil uil-horizontal-distribution-right',
  hospital: 'uil uil-hospital',
  hospitalSquareSign: 'uil uil-hospital-square-sign',
  hospitalSymbol: 'uil uil-hospital-symbol',
  hourglass: 'uil uil-hourglass',
  houseUser: 'uil uil-house-user',
  html3: 'uil uil-html3',
  html3Alt: 'uil uil-html3-alt',
  html5: 'uil uil-html5',
  html5Alt: 'uil uil-html5-alt',
  hunting: 'uil uil-hunting',
  icons: 'uil uil-icons',
  illustration: 'uil uil-illustration',
  image: 'uil uil-image',
  imageAltSlash: 'uil uil-image-alt-slash',
  imageBlock: 'uil uil-image-block',
  imageBroken: 'uil uil-image-broken',
  imageCheck: 'uil uil-image-check',
  imageDownload: 'uil uil-image-download',
  imageEdit: 'uil uil-image-edit',
  imageLock: 'uil uil-image-lock',
  imageMinus: 'uil uil-image-minus',
  imagePlus: 'uil uil-image-plus',
  imageQuestion: 'uil uil-image-question',
  imageRedo: 'uil uil-image-redo',
  imageResizeLandscape: 'uil uil-image-resize-landscape',
  imageResizeSquare: 'uil uil-image-resize-square',
  imageSearch: 'uil uil-image-search',
  imageShare: 'uil uil-image-share',
  imageShield: 'uil uil-image-shield',
  imageSlash: 'uil uil-image-slash',
  imageTimes: 'uil uil-image-times',
  imageUpload: 'uil uil-image-upload',
  imageV: 'uil uil-image-v',
  images: 'uil uil-images',
  import: 'uil uil-import',
  inbox: 'uil uil-inbox',
  incomingCall: 'uil uil-incoming-call',
  info: 'uil uil-info',
  infoCircle: 'uil uil-info-circle',
  instagram: 'uil uil-instagram',
  instagramAlt: 'uil uil-instagram-alt',
  intercom: 'uil uil-intercom',
  intercomAlt: 'uil uil-intercom-alt',
  invoice: 'uil uil-invoice',
  italic: 'uil uil-italic',
  jackhammer: 'uil uil-jackhammer',
  javaScript: 'uil uil-java-script',
  kayak: 'uil uil-kayak',
  keySkeleton: 'uil uil-key-skeleton',
  keySkeletonAlt: 'uil uil-key-skeleton-alt',
  keyboard: 'uil uil-keyboard',
  keyboardAlt: 'uil uil-keyboard-alt',
  keyboardHide: 'uil uil-keyboard-hide',
  keyboardShow: 'uil uil-keyboard-show',
  keyholeCircle: 'uil uil-keyhole-circle',
  keyholeSquare: 'uil uil-keyhole-square',
  keyholeSquareFull: 'uil uil-keyhole-square-full',
  kid: 'uil uil-kid',
  label: 'uil uil-label',
  labelAlt: 'uil uil-label-alt',
  lamp: 'uil uil-lamp',
  language: 'uil uil-language',
  laptop: 'uil uil-laptop',
  laptopCloud: 'uil uil-laptop-cloud',
  laptopConnection: 'uil uil-laptop-connection',
  laughing: 'uil uil-laughing',
  layerGroup: 'uil uil-layer-group',
  layerGroupSlash: 'uil uil-layer-group-slash',
  layers: 'uil uil-layers',
  layersAlt: 'uil uil-layers-alt',
  layersSlash: 'uil uil-layers-slash',
  leftArrowFromLeft: 'uil uil-left-arrow-from-left',
  leftArrowToLeft: 'uil uil-left-arrow-to-left',
  leftIndent: 'uil uil-left-indent',
  leftIndentAlt: 'uil uil-left-indent-alt',
  leftToRightTextDirection: 'uil uil-left-to-right-text-direction',
  letterChineseA: 'uil uil-letter-chinese-a',
  letterEnglishA: 'uil uil-letter-english-a',
  letterHindiA: 'uil uil-letter-hindi-a',
  letterJapaneseA: 'uil uil-letter-japanese-a',
  lifeRing: 'uil uil-life-ring',
  lightbulb: 'uil uil-lightbulb',
  lightbulbAlt: 'uil uil-lightbulb-alt',
  line: 'uil uil-line',
  lineAlt: 'uil uil-line-alt',
  lineSpacing: 'uil uil-line-spacing',
  link: 'uil uil-link',
  linkAdd: 'uil uil-link-add',
  linkAlt: 'uil uil-link-alt',
  linkBroken: 'uil uil-link-broken',
  linkH: 'uil uil-link-h',
  linkedin: 'uil uil-linkedin',
  linkedinAlt: 'uil uil-linkedin-alt',
  linux: 'uil uil-linux',
  liraSign: 'uil uil-lira-sign',
  listOl: 'uil uil-list-ol',
  listOlAlt: 'uil uil-list-ol-alt',
  listUiAlt: 'uil uil-list-ui-alt',
  listUl: 'uil uil-list-ul',
  locationArrow: 'uil uil-location-arrow',
  locationArrowAlt: 'uil uil-location-arrow-alt',
  locationPinAlt: 'uil uil-location-pin-alt',
  locationPoint: 'uil uil-location-point',
  lock: 'uil uil-lock',
  lockAccess: 'uil uil-lock-access',
  lockAlt: 'uil uil-lock-alt',
  lockOpenAlt: 'uil uil-lock-open-alt',
  lockSlash: 'uil uil-lock-slash',
  lottiefiles: 'uil uil-lottiefiles',
  lottiefilesAlt: 'uil uil-lottiefiles-alt',
  luggageCart: 'uil uil-luggage-cart',
  mailbox: 'uil uil-mailbox',
  mailboxAlt: 'uil uil-mailbox-alt',
  map: 'uil uil-map',
  mapMarker: 'uil uil-map-marker',
  mapMarkerAlt: 'uil uil-map-marker-alt',
  mapMarkerEdit: 'uil uil-map-marker-edit',
  mapMarkerInfo: 'uil uil-map-marker-info',
  mapMarkerMinus: 'uil uil-map-marker-minus',
  mapMarkerPlus: 'uil uil-map-marker-plus',
  mapMarkerQuestion: 'uil uil-map-marker-question',
  mapMarkerShield: 'uil uil-map-marker-shield',
  mapMarkerSlash: 'uil uil-map-marker-slash',
  mapPin: 'uil uil-map-pin',
  mapPinAlt: 'uil uil-map-pin-alt',
  mars: 'uil uil-mars',
  masterCard: 'uil uil-master-card',
  maximizeLeft: 'uil uil-maximize-left',
  medal: 'uil uil-medal',
  medicalDrip: 'uil uil-medical-drip',
  medicalSquare: 'uil uil-medical-square',
  medicalSquareFull: 'uil uil-medical-square-full',
  mediumM: 'uil uil-medium-m',
  medkit: 'uil uil-medkit',
  meetingBoard: 'uil uil-meeting-board',
  megaphone: 'uil uil-megaphone',
  meh: 'uil uil-meh',
  mehAlt: 'uil uil-meh-alt',
  mehClosedEye: 'uil uil-meh-closed-eye',
  message: 'uil uil-message',
  metro: 'uil uil-metro',
  microphone: 'uil uil-microphone',
  microphoneSlash: 'uil uil-microphone-slash',
  microscope: 'uil uil-microscope',
  microsoft: 'uil uil-microsoft',
  minus: 'uil uil-minus',
  minusCircle: 'uil uil-minus-circle',
  minusPath: 'uil uil-minus-path',
  minusSquare: 'uil uil-minus-square',
  minusSquareFull: 'uil uil-minus-square-full',
  missedCall: 'uil uil-missed-call',
  mobileAndroid: 'uil uil-mobile-android',
  mobileAndroidAlt: 'uil uil-mobile-android-alt',
  mobileVibrate: 'uil uil-mobile-vibrate',
  modem: 'uil uil-modem',
  moneyBill: 'uil uil-money-bill',
  moneyBillSlash: 'uil uil-money-bill-slash',
  moneyBillStack: 'uil uil-money-bill-stack',
  moneyInsert: 'uil uil-money-insert',
  moneyStack: 'uil uil-money-stack',
  moneyWithdraw: 'uil uil-money-withdraw',
  moneyWithdrawal: 'uil uil-money-withdrawal',
  moneybag: 'uil uil-moneybag',
  moneybagAlt: 'uil uil-moneybag-alt',
  monitor: 'uil uil-monitor',
  monitorHeartRate: 'uil uil-monitor-heart-rate',
  moon: 'uil uil-moon',
  moonEclipse: 'uil uil-moon-eclipse',
  moonset: 'uil uil-moonset',
  mountains: 'uil uil-mountains',
  mountainsSun: 'uil uil-mountains-sun',
  mouse: 'uil uil-mouse',
  mouseAlt: 'uil uil-mouse-alt',
  mouseAlt2: 'uil uil-mouse-alt-2',
  multiply: 'uil uil-multiply',
  music: 'uil uil-music',
  musicNote: 'uil uil-music-note',
  musicTuneSlash: 'uil uil-music-tune-slash',
  nA: 'uil uil-n-a',
  navigator: 'uil uil-navigator',
  nerd: 'uil uil-nerd',
  newspaper: 'uil uil-newspaper',
  ninja: 'uil uil-ninja',
  noEntry: 'uil uil-no-entry',
  notebooks: 'uil uil-notebooks',
  notes: 'uil uil-notes',
  objectGroup: 'uil uil-object-group',
  objectUngroup: 'uil uil-object-ungroup',
  octagon: 'uil uil-octagon',
  okta: 'uil uil-okta',
  opera: 'uil uil-opera',
  operaAlt: 'uil uil-opera-alt',
  outgoingCall: 'uil uil-outgoing-call',
  package: 'uil uil-package',
  padlock: 'uil uil-padlock',
  pagelines: 'uil uil-pagelines',
  pagerduty: 'uil uil-pagerduty',
  paintTool: 'uil uil-paint-tool',
  palette: 'uil uil-palette',
  panelAdd: 'uil uil-panel-add',
  panoramaH: 'uil uil-panorama-h',
  panoramaHAlt: 'uil uil-panorama-h-alt',
  panoramaV: 'uil uil-panorama-v',
  paperclip: 'uil uil-paperclip',
  paragraph: 'uil uil-paragraph',
  parcel: 'uil uil-parcel',
  parkingCircle: 'uil uil-parking-circle',
  parkingSquare: 'uil uil-parking-square',
  pathfinder: 'uil uil-pathfinder',
  pathfinderUnite: 'uil uil-pathfinder-unite',
  pause: 'uil uil-pause',
  pauseCircle: 'uil uil-pause-circle',
  paypal: 'uil uil-paypal',
  pen: 'uil uil-pen',
  pentagon: 'uil uil-pentagon',
  percentage: 'uil uil-percentage',
  phone: 'uil uil-phone',
  phoneAlt: 'uil uil-phone-alt',
  phonePause: 'uil uil-phone-pause',
  phoneSlash: 'uil uil-phone-slash',
  phoneTimes: 'uil uil-phone-times',
  phoneVolume: 'uil uil-phone-volume',
  picture: 'uil uil-picture',
  pizzaSlice: 'uil uil-pizza-slice',
  plane: 'uil uil-plane',
  planeArrival: 'uil uil-plane-arrival',
  planeDeparture: 'uil uil-plane-departure',
  planeFly: 'uil uil-plane-fly',
  play: 'uil uil-play',
  playCircle: 'uil uil-play-circle',
  plug: 'uil uil-plug',
  plus: 'uil uil-plus',
  plusCircle: 'uil uil-plus-circle',
  plusSquare: 'uil uil-plus-square',
  podium: 'uil uil-podium',
  polygon: 'uil uil-polygon',
  postStamp: 'uil uil-post-stamp',
  postcard: 'uil uil-postcard',
  pound: 'uil uil-pound',
  poundCircle: 'uil uil-pound-circle',
  power: 'uil uil-power',
  prescriptionBottle: 'uil uil-prescription-bottle',
  presentation: 'uil uil-presentation',
  presentationCheck: 'uil uil-presentation-check',
  presentationEdit: 'uil uil-presentation-edit',
  presentationLine: 'uil uil-presentation-line',
  presentationLinesAlt: 'uil uil-presentation-lines-alt',
  presentationMinus: 'uil uil-presentation-minus',
  presentationPlay: 'uil uil-presentation-play',
  presentationPlus: 'uil uil-presentation-plus',
  presentationTimes: 'uil uil-presentation-times',
  previous: 'uil uil-previous',
  pricetagAlt: 'uil uil-pricetag-alt',
  print: 'uil uil-print',
  printSlash: 'uil uil-print-slash',
  process: 'uil uil-process',
  processor: 'uil uil-processor',
  programmingLanguage: 'uil uil-programming-language',
  pump: 'uil uil-pump',
  puzzlePiece: 'uil uil-puzzle-piece',
  qrcodeScan: 'uil uil-qrcode-scan',
  question: 'uil uil-question',
  questionCircle: 'uil uil-question-circle',
  rainbow: 'uil uil-rainbow',
  raindrops: 'uil uil-raindrops',
  raindropsAlt: 'uil uil-raindrops-alt',
  react: 'uil uil-react',
  receipt: 'uil uil-receipt',
  receiptAlt: 'uil uil-receipt-alt',
  recordAudio: 'uil uil-record-audio',
  redditAlienAlt: 'uil uil-reddit-alien-alt',
  redo: 'uil uil-redo',
  refresh: 'uil uil-refresh',
  registered: 'uil uil-registered',
  repeat: 'uil uil-repeat',
  restaurant: 'uil uil-restaurant',
  rightIndentAlt: 'uil uil-right-indent-alt',
  rightToLeftTextDirection: 'uil uil-right-to-left-text-direction',
  robot: 'uil uil-robot',
  rocket: 'uil uil-rocket',
  ropeWay: 'uil uil-rope-way',
  rotate360: 'uil uil-rotate-360',
  rss: 'uil uil-rss',
  rssAlt: 'uil uil-rss-alt',
  rssInterface: 'uil uil-rss-interface',
  ruler: 'uil uil-ruler',
  rulerCombined: 'uil uil-ruler-combined',
  rupeeSign: 'uil uil-rupee-sign',
  sad: 'uil uil-sad',
  sadCry: 'uil uil-sad-cry',
  sadCrying: 'uil uil-sad-crying',
  sadDizzy: 'uil uil-sad-dizzy',
  sadSquint: 'uil uil-sad-squint',
  sanitizer: 'uil uil-sanitizer',
  sanitizerAlt: 'uil uil-sanitizer-alt',
  save: 'uil uil-save',
  scalingLeft: 'uil uil-scaling-left',
  scalingRight: 'uil uil-scaling-right',
  scenery: 'uil uil-scenery',
  schedule: 'uil uil-schedule',
  screw: 'uil uil-screw',
  scroll: 'uil uil-scroll',
  scrollH: 'uil uil-scroll-h',
  search: 'uil uil-search',
  searchAlt: 'uil uil-search-alt',
  searchMinus: 'uil uil-search-minus',
  searchPlus: 'uil uil-search-plus',
  selfie: 'uil uil-selfie',
  server: 'uil uil-server',
  serverAlt: 'uil uil-server-alt',
  serverConnection: 'uil uil-server-connection',
  serverNetwork: 'uil uil-server-network',
  serverNetworkAlt: 'uil uil-server-network-alt',
  servers: 'uil uil-servers',
  servicemark: 'uil uil-servicemark',
  setting: 'uil uil-setting',
  share: 'uil uil-share',
  shareAlt: 'uil uil-share-alt',
  shield: 'uil uil-shield',
  shieldCheck: 'uil uil-shield-check',
  shieldExclamation: 'uil uil-shield-exclamation',
  shieldPlus: 'uil uil-shield-plus',
  shieldQuestion: 'uil uil-shield-question',
  shieldSlash: 'uil uil-shield-slash',
  ship: 'uil uil-ship',
  shop: 'uil uil-shop',
  shoppingBag: 'uil uil-shopping-bag',
  shoppingBasket: 'uil uil-shopping-basket',
  shoppingCart: 'uil uil-shopping-cart',
  shoppingCartAlt: 'uil uil-shopping-cart-alt',
  shovel: 'uil uil-shovel',
  shrink: 'uil uil-shrink',
  shuffle: 'uil uil-shuffle',
  shutter: 'uil uil-shutter',
  shutterAlt: 'uil uil-shutter-alt',
  sick: 'uil uil-sick',
  sigma: 'uil uil-sigma',
  signAlt: 'uil uil-sign-alt',
  signInAlt: 'uil uil-sign-in-alt',
  signLeft: 'uil uil-sign-left',
  signOutAlt: 'uil uil-sign-out-alt',
  signRight: 'uil uil-sign-right',
  signal: 'uil uil-signal',
  signalAlt: 'uil uil-signal-alt',
  signalAlt3: 'uil uil-signal-alt-3',
  signin: 'uil uil-signin',
  signout: 'uil uil-signout',
  silence: 'uil uil-silence',
  silentSquint: 'uil uil-silent-squint',
  simCard: 'uil uil-sim-card',
  sitemap: 'uil uil-sitemap',
  skipForward: 'uil uil-skip-forward',
  skipForwardAlt: 'uil uil-skip-forward-alt',
  skipForwardCircle: 'uil uil-skip-forward-circle',
  skype: 'uil uil-skype',
  skypeAlt: 'uil uil-skype-alt',
  slack: 'uil uil-slack',
  slackAlt: 'uil uil-slack-alt',
  sliderH: 'uil uil-slider-h',
  sliderHRange: 'uil uil-slider-h-range',
  slidersV: 'uil uil-sliders-v',
  slidersVAlt: 'uil uil-sliders-v-alt',
  smile: 'uil uil-smile',
  smileBeam: 'uil uil-smile-beam',
  smileDizzy: 'uil uil-smile-dizzy',
  smileSquintWink: 'uil uil-smile-squint-wink',
  smileSquintWinkAlt: 'uil uil-smile-squint-wink-alt',
  smileWink: 'uil uil-smile-wink',
  smileWinkAlt: 'uil uil-smile-wink-alt',
  snapchatAlt: 'uil uil-snapchat-alt',
  snapchatGhost: 'uil uil-snapchat-ghost',
  snapchatSquare: 'uil uil-snapchat-square',
  snowFlake: 'uil uil-snow-flake',
  snowflake: 'uil uil-snowflake',
  snowflakeAlt: 'uil uil-snowflake-alt',
  socialDistancing: 'uil uil-social-distancing',
  sort: 'uil uil-sort',
  sortAmountDown: 'uil uil-sort-amount-down',
  sortAmountUp: 'uil uil-sort-amount-up',
  sorting: 'uil uil-sorting',
  spaceKey: 'uil uil-space-key',
  spade: 'uil uil-spade',
  sperms: 'uil uil-sperms',
  spin: 'uil uil-spin',
  spinner: 'uil uil-spinner',
  spinnerAlt: 'uil uil-spinner-alt',
  square: 'uil uil-square',
  squareFull: 'uil uil-square-full',
  squareShape: 'uil uil-square-shape',
  squint: 'uil uil-squint',
  star: 'uil uil-star',
  starHalfAlt: 'uil uil-star-half-alt',
  stepBackward: 'uil uil-step-backward',
  stepBackwardAlt: 'uil uil-step-backward-alt',
  stepBackwardCircle: 'uil uil-step-backward-circle',
  stepForward: 'uil uil-step-forward',
  stethoscope: 'uil uil-stethoscope',
  stethoscopeAlt: 'uil uil-stethoscope-alt',
  stopCircle: 'uil uil-stop-circle',
  stopwatch: 'uil uil-stopwatch',
  stopwatchSlash: 'uil uil-stopwatch-slash',
  store: 'uil uil-store',
  storeAlt: 'uil uil-store-alt',
  storeSlash: 'uil uil-store-slash',
  streering: 'uil uil-streering',
  stretcher: 'uil uil-stretcher',
  subject: 'uil uil-subject',
  subway: 'uil uil-subway',
  subwayAlt: 'uil uil-subway-alt',
  suitcase: 'uil uil-suitcase',
  suitcaseAlt: 'uil uil-suitcase-alt',
  sun: 'uil uil-sun',
  sunset: 'uil uil-sunset',
  surprise: 'uil uil-surprise',
  swatchbook: 'uil uil-swatchbook',
  swiggy: 'uil uil-swiggy',
  swimmer: 'uil uil-swimmer',
  sync: 'uil uil-sync',
  syncExclamation: 'uil uil-sync-exclamation',
  syncSlash: 'uil uil-sync-slash',
  syringe: 'uil uil-syringe',
  table: 'uil uil-table',
  tableTennis: 'uil uil-table-tennis',
  tablet: 'uil uil-tablet',
  tablets: 'uil uil-tablets',
  tachometerFast: 'uil uil-tachometer-fast',
  tachometerFastAlt: 'uil uil-tachometer-fast-alt',
  tag: 'uil uil-tag',
  tagAlt: 'uil uil-tag-alt',
  tape: 'uil uil-tape',
  taxi: 'uil uil-taxi',
  tear: 'uil uil-tear',
  telegram: 'uil uil-telegram',
  telegramAlt: 'uil uil-telegram-alt',
  telescope: 'uil uil-telescope',
  temperature: 'uil uil-temperature',
  temperatureEmpty: 'uil uil-temperature-empty',
  temperatureHalf: 'uil uil-temperature-half',
  temperatureMinus: 'uil uil-temperature-minus',
  temperaturePlus: 'uil uil-temperature-plus',
  temperatureQuarter: 'uil uil-temperature-quarter',
  temperatureThreeQuarter: 'uil uil-temperature-three-quarter',
  tennisBall: 'uil uil-tennis-ball',
  text: 'uil uil-text',
  textFields: 'uil uil-text-fields',
  textSize: 'uil uil-text-size',
  textStrikeThrough: 'uil uil-text-strike-through',
  th: 'uil uil-th',
  thLarge: 'uil uil-th-large',
  thSlash: 'uil uil-th-slash',
  thermometer: 'uil uil-thermometer',
  thumbsDown: 'uil uil-thumbs-down',
  thumbsUp: 'uil uil-thumbs-up',
  thunderstorm: 'uil uil-thunderstorm',
  thunderstormMoon: 'uil uil-thunderstorm-moon',
  thunderstormSun: 'uil uil-thunderstorm-sun',
  ticket: 'uil uil-ticket',
  times: 'uil uil-times',
  timesCircle: 'uil uil-times-circle',
  timesSquare: 'uil uil-times-square',
  toggleOff: 'uil uil-toggle-off',
  toggleOn: 'uil uil-toggle-on',
  toiletPaper: 'uil uil-toilet-paper',
  topArrowFromTop: 'uil uil-top-arrow-from-top',
  topArrowToTop: 'uil uil-top-arrow-to-top',
  tornado: 'uil uil-tornado',
  trademark: 'uil uil-trademark',
  trademarkCircle: 'uil uil-trademark-circle',
  trafficBarrier: 'uil uil-traffic-barrier',
  trafficLight: 'uil uil-traffic-light',
  transaction: 'uil uil-transaction',
  trash: 'uil uil-trash',
  trashAlt: 'uil uil-trash-alt',
  trees: 'uil uil-trees',
  triangle: 'uil uil-triangle',
  trophy: 'uil uil-trophy',
  trowel: 'uil uil-trowel',
  truck: 'uil uil-truck',
  truckLoading: 'uil uil-truck-loading',
  tumblr: 'uil uil-tumblr',
  tumblrAlt: 'uil uil-tumblr-alt',
  tumblrSquare: 'uil uil-tumblr-square',
  tvRetro: 'uil uil-tv-retro',
  tvRetroSlash: 'uil uil-tv-retro-slash',
  twitter: 'uil uil-twitter',
  twitterAlt: 'uil uil-twitter-alt',
  umbrella: 'uil uil-umbrella',
  unamused: 'uil uil-unamused',
  underline: 'uil uil-underline',
  university: 'uil uil-university',
  unlock: 'uil uil-unlock',
  unlockAlt: 'uil uil-unlock-alt',
  upload: 'uil uil-upload',
  uploadAlt: 'uil uil-upload-alt',
  usdCircle: 'uil uil-usd-circle',
  usdSquare: 'uil uil-usd-square',
  user: 'uil uil-user',
  userArrows: 'uil uil-user-arrows',
  userCheck: 'uil uil-user-check',
  userCircle: 'uil uil-user-circle',
  userExclamation: 'uil uil-user-exclamation',
  userLocation: 'uil uil-user-location',
  userMd: 'uil uil-user-md',
  userMinus: 'uil uil-user-minus',
  userNurse: 'uil uil-user-nurse',
  userPlus: 'uil uil-user-plus',
  userSquare: 'uil uil-user-square',
  userTimes: 'uil uil-user-times',
  usersAlt: 'uil uil-users-alt',
  utensils: 'uil uil-utensils',
  utensilsAlt: 'uil uil-utensils-alt',
  vectorSquare: 'uil uil-vector-square',
  vectorSquareAlt: 'uil uil-vector-square-alt',
  venus: 'uil uil-venus',
  verticalAlignBottom: 'uil uil-vertical-align-bottom',
  verticalAlignCenter: 'uil uil-vertical-align-center',
  verticalAlignTop: 'uil uil-vertical-align-top',
  verticalDistributeBottom: 'uil uil-vertical-distribute-bottom',
  verticalDistributionCenter: 'uil uil-vertical-distribution-center',
  verticalDistributionTop: 'uil uil-vertical-distribution-top',
  video: 'uil uil-video',
  videoQuestion: 'uil uil-video-question',
  videoSlash: 'uil uil-video-slash',
  virusSlash: 'uil uil-virus-slash',
  visualStudio: 'uil uil-visual-studio',
  vk: 'uil uil-vk',
  vkAlt: 'uil uil-vk-alt',
  voicemail: 'uil uil-voicemail',
  voicemailRectangle: 'uil uil-voicemail-rectangle',
  volleyball: 'uil uil-volleyball',
  volume: 'uil uil-volume',
  volumeDown: 'uil uil-volume-down',
  volumeMute: 'uil uil-volume-mute',
  volumeOff: 'uil uil-volume-off',
  volumeUp: 'uil uil-volume-up',
  vuejs: 'uil uil-vuejs',
  vuejsAlt: 'uil uil-vuejs-alt',
  wall: 'uil uil-wall',
  wallet: 'uil uil-wallet',
  watch: 'uil uil-watch',
  watchAlt: 'uil uil-watch-alt',
  water: 'uil uil-water',
  waterDropSlash: 'uil uil-water-drop-slash',
  waterGlass: 'uil uil-water-glass',
  webGrid: 'uil uil-web-grid',
  webGridAlt: 'uil uil-web-grid-alt',
  webSection: 'uil uil-web-section',
  webSectionAlt: 'uil uil-web-section-alt',
  webcam: 'uil uil-webcam',
  weight: 'uil uil-weight',
  whatsapp: 'uil uil-whatsapp',
  whatsappAlt: 'uil uil-whatsapp-alt',
  wheelBarrow: 'uil uil-wheel-barrow',
  wheelchair: 'uil uil-wheelchair',
  wheelchairAlt: 'uil uil-wheelchair-alt',
  wifi: 'uil uil-wifi',
  wifiRouter: 'uil uil-wifi-router',
  wifiSlash: 'uil uil-wifi-slash',
  wind: 'uil uil-wind',
  windMoon: 'uil uil-wind-moon',
  windSun: 'uil uil-wind-sun',
  window: 'uil uil-window',
  windowGrid: 'uil uil-window-grid',
  windowMaximize: 'uil uil-window-maximize',
  windowSection: 'uil uil-window-section',
  windows: 'uil uil-windows',
  windsock: 'uil uil-windsock',
  windy: 'uil uil-windy',
  wordpress: 'uil uil-wordpress',
  wordpressSimple: 'uil uil-wordpress-simple',
  wrapText: 'uil uil-wrap-text',
  wrench: 'uil uil-wrench',
  x: 'uil uil-x',
  xAdd: 'uil uil-x-add',
  yen: 'uil uil-yen',
  yenCircle: 'uil uil-yen-circle',
  yinYang: 'uil uil-yin-yang',
  youtube: 'uil uil-youtube',
  qrCode: 'uil uil-qrcode-scan',
  chevronLeft: 'uil uil-angle-left',
  chevronRight: 'uil uil-angle-right',
  close: 'uil uil-times',
  closeFill: 'uil uil-times-circle',
  chevronDown: 'uil uil-angle-down',
  chevronUp: 'uil uil-angle-up',
};

export const IconTypes = [
  'Plus0',
  'Plus10',
  'Plus12',
  'Plus13',
  'Plus16',
  'Plus17',
  'Plus18',
  'Plus21',
  'Plus3',
  'px500',
  'Plus6',
  'abacus',
  'accessibleIconAlt',
  'adjust',
  'adjustAlt',
  'adjustCircle',
  'adjustHalf',
  'adobe',
  'adobeAlt',
  'airplay',
  'align',
  'alignAlt',
  'alignCenter',
  'alignCenterAlt',
  'alignCenterH',
  'alignCenterJustify',
  'alignCenterV',
  'alignJustify',
  'alignLeft',
  'alignLeftJustify',
  'alignLetterRight',
  'alignRight',
  'alignRightJustify',
  'amazon',
  'ambulance',
  'analysis',
  'analytics',
  'anchor',
  'android',
  'androidAlt',
  'androidPhoneSlash',
  'angleDoubleDown',
  'angleDoubleLeft',
  'angleDoubleRight',
  'angleDoubleUp',
  'angleDown',
  'angleLeft',
  'angleLeftB',
  'angleRight',
  'angleRightB',
  'angleUp',
  'angry',
  'ankh',
  'annoyed',
  'annoyedAlt',
  'apple',
  'appleAlt',
  'apps',
  'archive',
  'archiveAlt',
  'archway',
  'arrow',
  'arrowBreak',
  'arrowCircleDown',
  'arrowCircleLeft',
  'arrowCircleRight',
  'arrowCircleUp',
  'arrowCompressH',
  'arrowDown',
  'arrowDownLeft',
  'arrowDownRight',
  'arrowFromRight',
  'arrowFromTop',
  'arrowGrowth',
  'arrowLeft',
  'arrowRandom',
  'arrowResizeDiagonal',
  'arrowRight',
  'arrowToBottom',
  'arrowToRight',
  'arrowUp',
  'arrowUpLeft',
  'arrowUpRight',
  'arrowsH',
  'arrowsHAlt',
  'arrowsLeftDown',
  'arrowsMaximize',
  'arrowsMerge',
  'arrowsResize',
  'arrowsResizeH',
  'arrowsResizeV',
  'arrowsRightDown',
  'arrowsShrinkH',
  'arrowsShrinkV',
  'arrowsUpRight',
  'arrowsV',
  'arrowsVAlt',
  'assistiveListeningSystems',
  'asterisk',
  'at',
  'atom',
  'autoFlash',
  'award',
  'awardAlt',
  'babyCarriage',
  'backpack',
  'backspace',
  'backward',
  'bag',
  'bagAlt',
  'bagSlash',
  'balanceScale',
  'ban',
  'bandAid',
  'bars',
  'baseballBall',
  'basketball',
  'basketballHoop',
  'bath',
  'batteryBolt',
  'batteryEmpty',
  'bed',
  'bedDouble',
  'behance',
  'behanceAlt',
  'bell',
  'bellSchool',
  'bellSlash',
  'bill',
  'bing',
  'bitcoin',
  'bitcoinAlt',
  'bitcoinCircle',
  'bitcoinSign',
  'blackBerry',
  'blogger',
  'bloggerAlt',
  'bluetoothB',
  'bold',
  'bolt',
  'boltAlt',
  'boltSlash',
  'book',
  'bookAlt',
  'bookMedical',
  'bookOpen',
  'bookReader',
  'bookmark',
  'bookmarkFull',
  'books',
  'boombox',
  'borderAlt',
  'borderBottom',
  'borderClear',
  'borderHorizontal',
  'borderInner',
  'borderLeft',
  'borderOut',
  'borderRight',
  'borderTop',
  'borderVertical',
  'bowlingBall',
  'box',
  'bracketsCurly',
  'brain',
  'briefcase',
  'briefcaseAlt',
  'bright',
  'brightness',
  'brightnessEmpty',
  'brightnessHalf',
  'brightnessLow',
  'brightnessMinus',
  'brightnessPlus',
  'bringBottom',
  'bringFront',
  'browser',
  'brushAlt',
  'bug',
  'building',
  'bullseye',
  'bus',
  'busAlt',
  'busSchool',
  'calculator',
  'calculatorAlt',
  'calendarAlt',
  'calendarSlash',
  'calender',
  'calling',
  'camera',
  'cameraChange',
  'cameraPlus',
  'cameraSlash',
  'cancel',
  'capsule',
  'capture',
  'car',
  'carSideview',
  'carSlash',
  'carWash',
  'cardAtm',
  'caretRight',
  'cell',
  'celsius',
  'channel',
  'channelAdd',
  'chart',
  'chartBar',
  'chartBarAlt',
  'chartDown',
  'chartGrowth',
  'chartGrowthAlt',
  'chartLine',
  'chartPie',
  'chartPieAlt',
  'chat',
  'chatBubbleUser',
  'chatInfo',
  'check',
  'checkCircle',
  'checkSquare',
  'circle',
  'circleLayer',
  'circuit',
  'clapperBoard',
  'clinicMedical',
  'clipboard',
  'clipboardAlt',
  'clipboardBlank',
  'clipboardNotes',
  'clock',
  'clockEight',
  'clockFive',
  'clockNine',
  'clockSeven',
  'clockTen',
  'clockThree',
  'clockTwo',
  'closedCaptioning',
  'closedCaptioningSlash',
  'cloud',
  'cloudBlock',
  'cloudBookmark',
  'cloudCheck',
  'cloudComputing',
  'cloudDataConnection',
  'cloudDatabaseTree',
  'cloudDownload',
  'cloudDrizzle',
  'cloudExclamation',
  'cloudHail',
  'cloudHeart',
  'cloudInfo',
  'cloudLock',
  'cloudMeatball',
  'cloudMoon',
  'cloudMoonHail',
  'cloudMoonMeatball',
  'cloudMoonRain',
  'cloudMoonShowers',
  'cloudQuestion',
  'cloudRain',
  'cloudRainSun',
  'cloudRedo',
  'cloudShare',
  'cloudShield',
  'cloudShowers',
  'cloudShowersAlt',
  'cloudShowersHeavy',
  'cloudSlash',
  'cloudSun',
  'cloudSunHail',
  'cloudSunMeatball',
  'cloudSunRain',
  'cloudSunRainAlt',
  'cloudSunTear',
  'cloudTimes',
  'cloudUnlock',
  'cloudUpload',
  'cloudWifi',
  'cloudWind',
  'clouds',
  'club',
  'codeBranch',
  'coffee',
  'cog',
  'coins',
  'columns',
  'comment',
  'commentAdd',
  'commentAlt',
  'commentAltBlock',
  'commentAltChartLines',
  'commentAltCheck',
  'commentAltDots',
  'commentAltDownload',
  'commentAltEdit',
  'commentAltExclamation',
  'commentAltHeart',
  'commentAltImage',
  'commentAltInfo',
  'commentAltLines',
  'commentAltLock',
  'commentAltMedical',
  'commentAltMessage',
  'commentAltNotes',
  'commentAltPlus',
  'commentAltQuestion',
  'commentAltRedo',
  'commentAltSearch',
  'commentAltShare',
  'commentAltShield',
  'commentAltSlash',
  'commentAltUpload',
  'commentAltVerify',
  'commentBlock',
  'commentChartLine',
  'commentCheck',
  'commentDots',
  'commentDownload',
  'commentEdit',
  'commentExclamation',
  'commentHeart',
  'commentImage',
  'commentInfo',
  'commentInfoAlt',
  'commentLines',
  'commentLock',
  'commentMedical',
  'commentMessage',
  'commentNotes',
  'commentPlus',
  'commentQuestion',
  'commentRedo',
  'commentSearch',
  'commentShare',
  'commentShield',
  'commentSlash',
  'commentUpload',
  'commentVerify',
  'comments',
  'commentsAlt',
  'compactDisc',
  'comparison',
  'compass',
  'compress',
  'compressAlt',
  'compressAltLeft',
  'compressArrows',
  'compressLines',
  'compressPoint',
  'compressV',
  'confused',
  'constructor',
  'copy',
  'copyAlt',
  'copyLandscape',
  'copyright',
  'cornerDownLeft',
  'cornerDownRight',
  'cornerDownRightAlt',
  'cornerLeftDown',
  'cornerRightDown',
  'cornerUpLeft',
  'cornerUpLeftAlt',
  'cornerUpRight',
  'cornerUpRightAlt',
  'coronavirus',
  'createDashboard',
  'creativeCommonsPd',
  'creditCard',
  'creditCardSearch',
  'crockery',
  'cropAlt',
  'cropAltRotateLeft',
  'cropAltRotateRight',
  'crosshair',
  'crosshairAlt',
  'crosshairs',
  'css3Simple',
  'cube',
  'dashboard',
  'dataSharing',
  'database',
  'databaseAlt',
  'desert',
  'desktop',
  'desktopAlt',
  'desktopAltSlash',
  'desktopCloudAlt',
  'desktopSlash',
  'dialpad',
  'dialpadAlt',
  'diamond',
  'diary',
  'diaryAlt',
  'diceFive',
  'diceFour',
  'diceOne',
  'diceSix',
  'diceThree',
  'diceTwo',
  'direction',
  'directions',
  'discord',
  'dizzyMeh',
  'dna',
  'docker',
  'documentInfo',
  'documentLayoutCenter',
  'documentLayoutLeft',
  'documentLayoutRight',
  'dollarAlt',
  'dollarSign',
  'dollarSignAlt',
  'downloadAlt',
  'draggabledots',
  'dribbble',
  'drill',
  'dropbox',
  'dumbbell',
  'ear',
  'edit',
  'editAlt',
  'elipsisDoubleVAlt',
  'ellipsisH',
  'ellipsisV',
  'emoji',
  'englishToChinese',
  'enter',
  'envelope',
  'envelopeAdd',
  'envelopeAlt',
  'envelopeBlock',
  'envelopeBookmark',
  'envelopeCheck',
  'envelopeDownload',
  'envelopeDownloadAlt',
  'envelopeEdit',
  'envelopeExclamation',
  'envelopeHeart',
  'envelopeInfo',
  'envelopeLock',
  'envelopeMinus',
  'envelopeOpen',
  'envelopeQuestion',
  'envelopeReceive',
  'envelopeRedo',
  'envelopeSearch',
  'envelopeSend',
  'envelopeShare',
  'envelopeShield',
  'envelopeStar',
  'envelopeTimes',
  'envelopeUpload',
  'envelopeUploadAlt',
  'envelopes',
  'equalCircle',
  'estate',
  'euro',
  'euroCircle',
  'exchange',
  'exchangeAlt',
  'exclamation',
  'exclamationCircle',
  'exclamationOctagon',
  'exclamationTriangle',
  'exclude',
  'expandAlt',
  'expandArrows',
  'expandArrowsAlt',
  'expandFromCorner',
  'expandLeft',
  'expandRight',
  'export',
  'exposureAlt',
  'exposureIncrease',
  'externalLinkAlt',
  'eye',
  'eyeSlash',
  'facebook',
  'facebookF',
  'facebookMessenger',
  'facebookMessengerAlt',
  'fahrenheit',
  'fastMail',
  'fastMailAlt',
  'favorite',
  'feedback',
  'fidgetSpinner',
  'file',
  'fileAlt',
  'fileBlank',
  'fileBlockAlt',
  'fileBookmarkAlt',
  'fileCheck',
  'fileCheckAlt',
  'fileContract',
  'fileContractDollar',
  'fileCopyAlt',
  'fileDownload',
  'fileDownloadAlt',
  'fileEditAlt',
  'fileExclamation',
  'fileExclamationAlt',
  'fileExport',
  'fileGraph',
  'fileHeart',
  'fileImport',
  'fileInfoAlt',
  'fileLandscape',
  'fileLandscapeAlt',
  'fileLanscapeSlash',
  'fileLockAlt',
  'fileMedical',
  'fileMedicalAlt',
  'fileMinus',
  'fileMinusAlt',
  'fileNetwork',
  'filePlus',
  'filePlusAlt',
  'fileQuestion',
  'fileQuestionAlt',
  'fileRedoAlt',
  'fileSearchAlt',
  'fileShareAlt',
  'fileShieldAlt',
  'fileSlash',
  'fileTimes',
  'fileTimesAlt',
  'fileUpload',
  'fileUploadAlt',
  'filesLandscapes',
  'filesLandscapesAlt',
  'film',
  'filter',
  'filterSlash',
  'fire',
  'flask',
  'flaskPotion',
  'flipH',
  'flipHAlt',
  'flipV',
  'flipVAlt',
  'flower',
  'focus',
  'focusAdd',
  'focusTarget',
  'folder',
  'folderCheck',
  'folderDownload',
  'folderExclamation',
  'folderHeart',
  'folderInfo',
  'folderLock',
  'folderMedical',
  'folderMinus',
  'folderNetwork',
  'folderOpen',
  'folderPlus',
  'folderQuestion',
  'folderSlash',
  'folderTimes',
  'folderUpload',
  'font',
  'football',
  'footballAmerican',
  'footballBall',
  'forecastcloudMoonTear',
  'forwadedCall',
  'forward',
  'frown',
  'gameStructure',
  'gift',
  'github',
  'githubAlt',
  'gitlab',
  'glass',
  'glassMartini',
  'glassMartiniAlt',
  'glassMartiniAltSlash',
  'glassTea',
  'globe',
  'gold',
  'golfBall',
  'google',
  'googleDrive',
  'googleDriveAlt',
  'googleHangouts',
  'googleHangoutsAlt',
  'googlePlay',
  'graduationCap',
  'graphBar',
  'grid',
  'grids',
  'grin',
  'grinTongueWink',
  'grinTongueWinkAlt',
  'gripHorizontalLine',
  'hardHat',
  'hdd',
  'headSide',
  'headSideCough',
  'headSideMask',
  'headphoneSlash',
  'headphones',
  'headphonesAlt',
  'heart',
  'heartAlt',
  'heartBreak',
  'heartMedical',
  'heartRate',
  'heartSign',
  'heartbeat',
  'hindiToChinese',
  'hipchat',
  'history',
  'historyAlt',
  'home',
  'horizontalAlignCenter',
  'horizontalAlignLeft',
  'horizontalAlignRight',
  'horizontalDistributionCenter',
  'horizontalDistributionLeft',
  'horizontalDistributionRight',
  'hospital',
  'hospitalSquareSign',
  'hospitalSymbol',
  'hourglass',
  'houseUser',
  'html3',
  'html3Alt',
  'html5',
  'html5Alt',
  'hunting',
  'icons',
  'illustration',
  'image',
  'imageAltSlash',
  'imageBlock',
  'imageBroken',
  'imageCheck',
  'imageDownload',
  'imageEdit',
  'imageLock',
  'imageMinus',
  'imagePlus',
  'imageQuestion',
  'imageRedo',
  'imageResizeLandscape',
  'imageResizeSquare',
  'imageSearch',
  'imageShare',
  'imageShield',
  'imageSlash',
  'imageTimes',
  'imageUpload',
  'imageV',
  'images',
  'import',
  'inbox',
  'incomingCall',
  'info',
  'infoCircle',
  'instagram',
  'instagramAlt',
  'intercom',
  'intercomAlt',
  'invoice',
  'italic',
  'jackhammer',
  'javaScript',
  'kayak',
  'keySkeleton',
  'keySkeletonAlt',
  'keyboard',
  'keyboardAlt',
  'keyboardHide',
  'keyboardShow',
  'keyholeCircle',
  'keyholeSquare',
  'keyholeSquareFull',
  'kid',
  'label',
  'labelAlt',
  'lamp',
  'language',
  'laptop',
  'laptopCloud',
  'laptopConnection',
  'laughing',
  'layerGroup',
  'layerGroupSlash',
  'layers',
  'layersAlt',
  'layersSlash',
  'leftArrowFromLeft',
  'leftArrowToLeft',
  'leftIndent',
  'leftIndentAlt',
  'leftToRightTextDirection',
  'letterChineseA',
  'letterEnglishA',
  'letterHindiA',
  'letterJapaneseA',
  'lifeRing',
  'lightbulb',
  'lightbulbAlt',
  'line',
  'lineAlt',
  'lineSpacing',
  'link',
  'linkAdd',
  'linkAlt',
  'linkBroken',
  'linkH',
  'linkedin',
  'linkedinAlt',
  'linux',
  'liraSign',
  'listOl',
  'listOlAlt',
  'listUiAlt',
  'listUl',
  'locationArrow',
  'locationArrowAlt',
  'locationPinAlt',
  'locationPoint',
  'lock',
  'lockAccess',
  'lockAlt',
  'lockOpenAlt',
  'lockSlash',
  'lottiefiles',
  'lottiefilesAlt',
  'luggageCart',
  'mailbox',
  'mailboxAlt',
  'map',
  'mapMarker',
  'mapMarkerAlt',
  'mapMarkerEdit',
  'mapMarkerInfo',
  'mapMarkerMinus',
  'mapMarkerPlus',
  'mapMarkerQuestion',
  'mapMarkerShield',
  'mapMarkerSlash',
  'mapPin',
  'mapPinAlt',
  'mars',
  'masterCard',
  'maximizeLeft',
  'medal',
  'medicalDrip',
  'medicalSquare',
  'medicalSquareFull',
  'mediumM',
  'medkit',
  'meetingBoard',
  'megaphone',
  'meh',
  'mehAlt',
  'mehClosedEye',
  'message',
  'metro',
  'microphone',
  'microphoneSlash',
  'microscope',
  'microsoft',
  'minus',
  'minusCircle',
  'minusPath',
  'minusSquare',
  'minusSquareFull',
  'missedCall',
  'mobileAndroid',
  'mobileAndroidAlt',
  'mobileVibrate',
  'modem',
  'moneyBill',
  'moneyBillSlash',
  'moneyBillStack',
  'moneyInsert',
  'moneyStack',
  'moneyWithdraw',
  'moneyWithdrawal',
  'moneybag',
  'moneybagAlt',
  'monitor',
  'monitorHeartRate',
  'moon',
  'moonEclipse',
  'moonset',
  'mountains',
  'mountainsSun',
  'mouse',
  'mouseAlt',
  'mouseAlt2',
  'multiply',
  'music',
  'musicNote',
  'musicTuneSlash',
  'nA',
  'navigator',
  'nerd',
  'newspaper',
  'ninja',
  'noEntry',
  'notebooks',
  'notes',
  'objectGroup',
  'objectUngroup',
  'octagon',
  'okta',
  'opera',
  'operaAlt',
  'outgoingCall',
  'package',
  'padlock',
  'pagelines',
  'pagerduty',
  'paintTool',
  'palette',
  'panelAdd',
  'panoramaH',
  'panoramaHAlt',
  'panoramaV',
  'paperclip',
  'paragraph',
  'parcel',
  'parkingCircle',
  'parkingSquare',
  'pathfinder',
  'pathfinderUnite',
  'pause',
  'pauseCircle',
  'paypal',
  'pen',
  'pentagon',
  'percentage',
  'phone',
  'phoneAlt',
  'phonePause',
  'phoneSlash',
  'phoneTimes',
  'phoneVolume',
  'picture',
  'pizzaSlice',
  'plane',
  'planeArrival',
  'planeDeparture',
  'planeFly',
  'play',
  'playCircle',
  'plug',
  'plus',
  'plusCircle',
  'plusSquare',
  'podium',
  'polygon',
  'postStamp',
  'postcard',
  'pound',
  'poundCircle',
  'power',
  'prescriptionBottle',
  'presentation',
  'presentationCheck',
  'presentationEdit',
  'presentationLine',
  'presentationLinesAlt',
  'presentationMinus',
  'presentationPlay',
  'presentationPlus',
  'presentationTimes',
  'previous',
  'pricetagAlt',
  'print',
  'printSlash',
  'process',
  'processor',
  'programmingLanguage',
  'pump',
  'puzzlePiece',
  'qrcodeScan',
  'question',
  'questionCircle',
  'rainbow',
  'raindrops',
  'raindropsAlt',
  'react',
  'receipt',
  'receiptAlt',
  'recordAudio',
  'redditAlienAlt',
  'redo',
  'refresh',
  'registered',
  'repeat',
  'restaurant',
  'rightIndentAlt',
  'rightToLeftTextDirection',
  'robot',
  'rocket',
  'ropeWay',
  'rotate360',
  'rss',
  'rssAlt',
  'rssInterface',
  'ruler',
  'rulerCombined',
  'rupeeSign',
  'sad',
  'sadCry',
  'sadCrying',
  'sadDizzy',
  'sadSquint',
  'sanitizer',
  'sanitizerAlt',
  'save',
  'scalingLeft',
  'scalingRight',
  'scenery',
  'schedule',
  'screw',
  'scroll',
  'scrollH',
  'search',
  'searchAlt',
  'searchMinus',
  'searchPlus',
  'selfie',
  'server',
  'serverAlt',
  'serverConnection',
  'serverNetwork',
  'serverNetworkAlt',
  'servers',
  'servicemark',
  'setting',
  'share',
  'shareAlt',
  'shield',
  'shieldCheck',
  'shieldExclamation',
  'shieldPlus',
  'shieldQuestion',
  'shieldSlash',
  'ship',
  'shop',
  'shoppingBag',
  'shoppingBasket',
  'shoppingCart',
  'shoppingCartAlt',
  'shovel',
  'shrink',
  'shuffle',
  'shutter',
  'shutterAlt',
  'sick',
  'sigma',
  'signAlt',
  'signInAlt',
  'signLeft',
  'signOutAlt',
  'signRight',
  'signal',
  'signalAlt',
  'signalAlt3',
  'signin',
  'signout',
  'silence',
  'silentSquint',
  'simCard',
  'sitemap',
  'skipForward',
  'skipForwardAlt',
  'skipForwardCircle',
  'skype',
  'skypeAlt',
  'slack',
  'slackAlt',
  'sliderH',
  'sliderHRange',
  'slidersV',
  'slidersVAlt',
  'smile',
  'smileBeam',
  'smileDizzy',
  'smileSquintWink',
  'smileSquintWinkAlt',
  'smileWink',
  'smileWinkAlt',
  'snapchatAlt',
  'snapchatGhost',
  'snapchatSquare',
  'snowFlake',
  'snowflake',
  'snowflakeAlt',
  'socialDistancing',
  'sort',
  'sortAmountDown',
  'sortAmountUp',
  'sorting',
  'spaceKey',
  'spade',
  'sperms',
  'spin',
  'spinner',
  'spinnerAlt',
  'square',
  'squareFull',
  'squareShape',
  'squint',
  'star',
  'starHalfAlt',
  'stepBackward',
  'stepBackwardAlt',
  'stepBackwardCircle',
  'stepForward',
  'stethoscope',
  'stethoscopeAlt',
  'stopCircle',
  'stopwatch',
  'stopwatchSlash',
  'store',
  'storeAlt',
  'storeSlash',
  'streering',
  'stretcher',
  'subject',
  'subway',
  'subwayAlt',
  'suitcase',
  'suitcaseAlt',
  'sun',
  'sunset',
  'surprise',
  'swatchbook',
  'swiggy',
  'swimmer',
  'sync',
  'syncExclamation',
  'syncSlash',
  'syringe',
  'table',
  'tableTennis',
  'tablet',
  'tablets',
  'tachometerFast',
  'tachometerFastAlt',
  'tag',
  'tagAlt',
  'tape',
  'taxi',
  'tear',
  'telegram',
  'telegramAlt',
  'telescope',
  'temperature',
  'temperatureEmpty',
  'temperatureHalf',
  'temperatureMinus',
  'temperaturePlus',
  'temperatureQuarter',
  'temperatureThreeQuarter',
  'tennisBall',
  'text',
  'textFields',
  'textSize',
  'textStrikeThrough',
  'th',
  'thLarge',
  'thSlash',
  'thermometer',
  'thumbsDown',
  'thumbsUp',
  'thunderstorm',
  'thunderstormMoon',
  'thunderstormSun',
  'ticket',
  'times',
  'timesCircle',
  'timesSquare',
  'toggleOff',
  'toggleOn',
  'toiletPaper',
  'topArrowFromTop',
  'topArrowToTop',
  'tornado',
  'trademark',
  'trademarkCircle',
  'trafficBarrier',
  'trafficLight',
  'transaction',
  'trash',
  'trashAlt',
  'trees',
  'triangle',
  'trophy',
  'trowel',
  'truck',
  'truckLoading',
  'tumblr',
  'tumblrAlt',
  'tumblrSquare',
  'tvRetro',
  'tvRetroSlash',
  'twitter',
  'twitterAlt',
  'umbrella',
  'unamused',
  'underline',
  'university',
  'unlock',
  'unlockAlt',
  'upload',
  'uploadAlt',
  'usdCircle',
  'usdSquare',
  'user',
  'userArrows',
  'userCheck',
  'userCircle',
  'userExclamation',
  'userLocation',
  'userMd',
  'userMinus',
  'userNurse',
  'userPlus',
  'userSquare',
  'userTimes',
  'usersAlt',
  'utensils',
  'utensilsAlt',
  'vectorSquare',
  'vectorSquareAlt',
  'venus',
  'verticalAlignBottom',
  'verticalAlignCenter',
  'verticalAlignTop',
  'verticalDistributeBottom',
  'verticalDistributionCenter',
  'verticalDistributionTop',
  'video',
  'videoQuestion',
  'videoSlash',
  'virusSlash',
  'visualStudio',
  'vk',
  'vkAlt',
  'voicemail',
  'voicemailRectangle',
  'volleyball',
  'volume',
  'volumeDown',
  'volumeMute',
  'volumeOff',
  'volumeUp',
  'vuejs',
  'vuejsAlt',
  'wall',
  'wallet',
  'watch',
  'watchAlt',
  'water',
  'waterDropSlash',
  'waterGlass',
  'webGrid',
  'webGridAlt',
  'webSection',
  'webSectionAlt',
  'webcam',
  'weight',
  'whatsapp',
  'whatsappAlt',
  'wheelBarrow',
  'wheelchair',
  'wheelchairAlt',
  'wifi',
  'wifiRouter',
  'wifiSlash',
  'wind',
  'windMoon',
  'windSun',
  'window',
  'windowGrid',
  'windowMaximize',
  'windowSection',
  'windows',
  'windsock',
  'windy',
  'wordpress',
  'wordpressSimple',
  'wrapText',
  'wrench',
  'x',
  'xAdd',
  'yen',
  'yenCircle',
  'yinYang',
  'youtube',
  'qrCode',
  'chevronLeft',
  'chevronRight',
  'close',
  'closeFill',
  'chevronDown',
  'chevronUp',
] as const;
